import React, { useState } from "react";
import Layout from "../component/Layout/Layout";
import "react-multi-carousel/lib/styles.css";
import {
  useTesimonialAPI
} from "../hooks/useAllCategoryData";
import parse from "html-react-parser";
import YoutubeTestimonial from "./YoutubeTestimonial";

export default function Testimonial() {
  const [getAttr, setGetAttr] = useState("");
  const [isActive, setActive] = useState(0);
  const [getimgAttr, setGetimgAttr] = useState("");
  const [isimgActive, setimgActive] = useState("false");
  const [selectedimg, setSelectedimg] = useState("");
  // const { data: test } = useTestmoYoutubeAPI();
  const { isLoading, error, data: testimonial } = useTesimonialAPI();
  if (error) return <div>{error.message}</div>;
  //console.log(test+"----")
  //const { isLoading, error, data:testimonial } = useYoutubeAPI();
 

  let getalt = (e) => {
    setGetAttr(e.target.getAttribute("alt"));
    setActive(!isActive);
  };

  let imggetalt = (e) => {
    setSelectedimg(e.target.getAttribute("src"));
    setimgActive(!isimgActive);
  };


  return (
    <Layout title="Testimonial | Chaashni Couture">
      <div className="site-content-wrap static-page">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="content-box testimonial-wrap">
                <div className="testimonial-wrap">
                  <div className="testimonial-head testimonial-box-head">
                    <div className="chaashnilove-img">
                      <img src="./images/chaashnilove-im-small.png" alt="" />
                    </div>
                  </div>
                  <YoutubeTestimonial getAt={setGetAttr} setActive={setActive}/>
                  <div className="testimonial-list-box">
                    {testimonial?.testimonials?.map((e, i) => (
                      <div key={i} className="testimonial-box">
                        <div className="testi-content">
                          {e.profile_image && (
                            <div className="testi-photo">
                              <img
                                width={150}
                                height={150}
                                src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/testimonial_profile/${e.profile_image}`}
                                className="attachment-thumbnail size-thumbnail wp-post-image"
                                alt={e.name}
                              />
                            </div>
                          )}
                          <div className="testi-text">
                          <div className="testi-text-box">
                            {parse(e.description)}
                            </div>
                            {JSON.parse(e.image_gallery).length > 0 && (
                              <div className="testi-timg-gallery">
                                {JSON.parse(e.image_gallery)?.map((item) => (
                                  <img
                                    src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/testimonial_gallery/${item}`}
                                    alt=""
                                    width={384}
                                    height={512}
                                    onClick={imggetalt}
                                  />
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="testi-author-name">
                          <span className="testiname">-- {e.name}</span>
                          {/*<span className="testi-link"> </span>*/}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className={isActive ? "yt-video show-video" : "yt-video"}>
        <div className="yt-overlay">
          <span className="close-btn cursor" onClick={getalt}></span>
        </div>
        <div className="youtube-iframe">
          <img src="./images/short-video.png" alt="" />
          <iframe
            width="147"
            height="261"
            src={`https://www.youtube.com/embed/${getAttr}?rel=0&amp;autoplay=1`}
            data-autoplay-src={`https://www.youtube.com/embed/${getAttr}?rel=0&amp;autoplay=1`}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen=""
          ></iframe>
        </div>
      </div>

      <div className={isimgActive ? "yt-img" : "yt-img show-video"}>
        <div className="yt-img-overlay"><span className="close-btn" onClick={imggetalt}></span></div>
        <div className="yt-img-iframe"><img src={selectedimg} alt="" /></div>
      </div>
    </Layout>
  );
}
